import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/category/tian-douhua', label: t('nav.categories') },
    { path: '/about', label: t('nav.about') },
  ];

  const navbarBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textColor = isHome && !scrolled
    ? 'text-background-50'
    : 'text-foreground-800';

  const linkHoverColor = isHome && !scrolled
    ? 'hover:text-primary-200'
    : 'hover:text-primary-600';

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${navbarBg} ${scrolled ? 'border-b border-background-200/70' : ''}`}>
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide transition-colors duration-300 ${textColor}`}>
              91豆花
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${textColor} ${linkHoverColor} ${location.pathname === link.path ? (isHome && !scrolled ? 'text-primary-200' : 'text-primary-600') : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:400-910-0000"
              className={`flex items-center gap-1.5 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${textColor} ${linkHoverColor}`}
            >
              <i className="ri-phone-line text-base"></i>
              <span>400-910-0000</span>
            </a>
          </div>

          <button
            type="button"
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textColor}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 cursor-pointer ${location.pathname === link.path ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:400-910-0000"
              className="flex items-center gap-2 text-sm font-medium py-2 px-3 text-foreground-700 hover:bg-background-100 rounded-lg transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              400-910-0000
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}